import { HeadlessFormProvider } from '@delmonicos/shared-design-system-react/src/contexts/headless-form.provider';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetRfidBadgeOrdersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/rfid-badge-orders/get-rfid-badge-orders-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterSearchEmspBoRfidBadgeOrderListContext } from '../../emsp-bo-rfid-badge-order.context';
import { EmspBoRfidBadgeOrderListFilterSearchFormStep1Controller } from '../emsp-bo-rfid-badge-order-list-filter-search-form-step-1/emsp-bo-rfid-badge-order-list-filter-search-form-step-1.controller';

export interface EmspBoRfidBadgeOrderListFilterSearchFormControllerProps {
  onError: SubmitErrorHandler<GetRfidBadgeOrdersPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetRfidBadgeOrdersPaginatedModel>;
  onCancel: () => void;
}

export const EmspBoRfidBadgeOrderListFilterSearchFormController = (
  props: EmspBoRfidBadgeOrderListFilterSearchFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterSearchEmspBoRfidBadgeOrderListContext();

  return (
    <HeadlessFormProvider<GetRfidBadgeOrdersPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      item={{
        fields: ['textToSearch'],
        component: <EmspBoRfidBadgeOrderListFilterSearchFormStep1Controller />,
      }}
    />
  );
};
